import React from 'react';

export default function NotFound() {
  return (
    <div className="container">
      <h1>Error! 404!</h1>
      <p>Not Found!</p>
    </div>
  );
}
